import { createFileRoute } from '@tanstack/react-router'
import { createStore, Provider } from 'jotai'
import z from 'zod'

import KLBPetaniPage from '@/components/pages/guest/_search/containers/klb-petani-page'

export const Route = createFileRoute('/_guest/guest/search/klb-farmers')({
  component: RouteComponent,
  validateSearch: z.object({
    type: z.string().optional(),
    province_code: z.string().optional(),
    city_code: z.string().optional(),
    district_code: z.string().optional(),
    page: z.number().min(1).optional().default(1),
    per_page: z.number().min(10).max(100).optional().default(50)
  })
})

const store = createStore()

function RouteComponent() {
  return (
    <Provider store={store}>
      <KLBPetaniPage />
    </Provider>
  )
}
